<p-dialog
  header="Error"
  [(visible)]="showDialog"
  [modal]="true"
  [style]="{ margin: '0 2rem', minWidth: '300px' }"
>
  <ng-template pTemplate="header">
    <div class="flex flex-column">
      <img src="assets/icons/sp_alert.svg" width="56" height="56" alt="" />
      <span class="t-20-600-primary mt-2">{{ errorBody?.description ? errorBody?.description : 'No tienes conexión a internet.'}}</span>
    </div>
  </ng-template>
  <ng-template pTemplate="content">
    <ul *ngIf="errorBody && errorBody.detail && errorBody.detail.length > 1">
      <li class="t-14-400-dark" *ngFor="let error of errorBody.detail">{{error}}</li>
    </ul>    
    <p class="t-14-400-dark" *ngIf="errorBody && errorBody.detail && errorBody.detail.length === 1">{{ errorBody.detail[0] }}</p>
    <p class="t-14-400-dark" *ngIf="!errorBody">Por favor, inténtalo nuevamente.</p>
    <p class="t-14-400-dark" *ngIf="!errorBody?.description">Por favor, verifica tu conexión e inténtalo nuevamente.</p>
  </ng-template>
  <ng-template pTemplate="footer" class="pt-5">
    <p-button label="Aceptar" (click)="closeModal()"></p-button>
  </ng-template>
</p-dialog>
